export default __webpack_public_path__ + "static/media/fAbeNcake_w1024.1d216c7e.jpeg";